<template>
  <EditContactsPage
    :get-gql-query="getGqlQuery"
    :get-total-count="getTotalCount"
    :get-contacts="getContacts"
    :get-query-variables="getQueryVariables"
    :update-query-variable="updateQueryVariable"
  />
</template>

<script>
import EditContactsPage from '@/pages/Contact/EditContactsPage'
import { LIST_EDIT_CATEGORY_CONTACTS } from '@/backend/graphql/categoryGQL'
export default {
  name: 'EditCategoryContactsPage',
  components: {
    EditContactsPage
  },
  data: function () {
    return {
      getGqlQuery: LIST_EDIT_CATEGORY_CONTACTS,
      limit: 50,
      offset: 0,
      orderBy: '-profile__id,-profile__last_recv_at',
      categoryId: 0,
      profileIsDelete: 0
    }
  },
  created () {
    this.categoryId = this.$route.params.categoryId
  },
  methods: {
    getTotalCount (data) {
      return data.listCategoryProfile.totalCount
    },
    getContacts (data) {
      return data.listCategoryProfile.results.map(obj => obj.profile)
    },
    getQueryVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        categoryId: this.categoryId,
        profileIsDelete: this.profileIsDelete
      }
    },
    updateQueryVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    }
  }
}
</script>

<style scoped>

</style>
